import { recipientsImportFileValidation } from "../../../validations"
import formatStringCsvToRecipient from "./formatStringCsvToRecipient"
import { CsvToRecipientData } from "./types"

const handleNewFile = async (event) : Promise<CsvToRecipientData[]> =>  {

    const files = event.target?.files ?? []
    if (files.length > 0) {
        const validation = await recipientsImportFileValidation(files[0])
        if(validation != ""){
            throw new Error(validation)
        }

        return files[0].text().then(text => {
            return formatStringCsvToRecipient(text)
        })
    }
}

export default handleNewFile